<template>
	<div class="chatroomError">抱歉，服务器出错了。</div>
</template>
<script>
export default {
	name: '500',
	props: [],
	data() {
		return {}
	},
	methods: {}
}
</script>
 
<style scoped>
.chatroomError {
	font-size: 24px;
	text-align: center;
	margin-top: 10%;
	font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/errorPage/500.vue